import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormControl,
  Validators,
  AbstractControl,
  ValidatorFn,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { AuthService } from '../../../core/abstraction/auth.service';
import { Utils } from 'src/app/pages/core/utils/Utils';
import { environment } from '../../../../../environments/environment';
import { AuthUtilsService } from '../../utils/auth-utils.service';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent implements OnInit {
  iosApp: string = environment.iosApp;
  verificationCode: string;
  passwordChanged = false;
  seePassword = false;
  seeRepPassword = false;

  passwordControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
  ]);

  repeatPasswordControl: FormControl = new FormControl('', [
    Validators.required,
    this.repeatControlValidator(this.passwordControl),
  ]);

  recoverPasswordForm: FormGroup = this.fb.group({
    passwordControl: this.passwordControl,
    repeatPasswordControl: this.repeatPasswordControl,
  });

  constructor(
    private fb: FormBuilder,
    public authService: AuthService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public utils: AuthUtilsService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((data) => {
      this.verificationCode = data.code;
    });
    if (Utils.isIOSDevice()) {
      window.location.href = `${
        this.iosApp
      }://recoverPassword?verificationCode=${encodeURIComponent(this.verificationCode)}`;
    } else if (Utils.isAndroidDevice()) {
      window.location.href = `tiendacrypto://changepassword?code=${encodeURIComponent(
        this.verificationCode,
      )}`;
    }
  }

  changePassword() {
    this.seePassword = false;
    this.seeRepPassword = false;
    if (this.recoverPasswordForm.invalid) {
      this.utils.touchControls(this.recoverPasswordForm);
      return;
    }
    this.authService
      .changePassword(this.verificationCode, this.passwordControl.value as string)
      .subscribe(
        () => {
          this.passwordChanged = true;
          this.dialog
            .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'Contraseña cambiada',
                content: `Tu contraseña fue cambiada exitosamente. Ya podés iniciar sesión con la nueva contraseña.`,
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.router.navigate(['auth', 'signin']);
            });
        },
        (err) => {
          this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Error cambiando contraseña',
              content: `Hubo un error al cambiar tu contraseña, por favor intentá nuevamente.`,
            },
          });
          console.log(err);
        },
      );
  }

  repeatControlValidator(repeatable: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null =>
      control.value !== repeatable.value ? { notRepeated: true } : null;
  }
}
